import { createAction } from 'typesafe-actions';
import { BankTransactionListResponse } from 'types/dto';
import { SortInfo } from 'types/sort';
import { PaginatedTransactionListRequestQuery } from 'types/transport';

export enum BankTransactionAction {
  Clear = 'BANK_TRANSACTION_CLEAR',
  Error = 'BANK_TRANSACTION_ERROR',
  ListRequest = 'BANK_TRANSACTION_LIST_REQUEST',
  ListResponse = 'BANK_TRANSACTION_LIST_RESPONSE',
  Query = 'BANK_TRANSACTION_QUERY',
  Select = 'BANK_TRANSACTION_SELECT',
  Sort = 'BANK_TRANSACTION_SORT',
}

export const bankTransactionClear = createAction(BankTransactionAction.Clear)();
export const bankTransactionError = createAction(BankTransactionAction.Error)<Error>();
export const bankTransactionListRequest = createAction(
  BankTransactionAction.ListRequest,
)<PaginatedTransactionListRequestQuery>();
export const bankTransactionListResponse = createAction(
  BankTransactionAction.ListResponse,
)<BankTransactionListResponse>();
export const bankTransactionQuery = createAction(BankTransactionAction.Query)<string>();
export const bankTransactionSelect = createAction(BankTransactionAction.Select)<Array<string>>();
export const bankTransactionSort = createAction(BankTransactionAction.Sort)<SortInfo>();
